import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalSpace: ExperimentalQueries['experimentalSpace'] = (
	_,
	{ spaceKey },
	{ network },
) =>
	fetchJSON(network, `/wiki/rest/api/space/${spaceKey}/settings`, {
		cache: 'no-cache',
		headers: {
			'Content-Type': MediaType.JSON,
		},
	}).then(
		(payload) => ({
			statusCode: payload?.statusCode || 200,
		}),
		(reason) => ({
			statusCode: network.BadStatusError.isBadStatusError(reason) ? reason.response.status : 404,
		}),
	);
